import React, { useState } from 'react';

export default function Footer(){
  
  return(
    <footer className='footer'>
      <h6>&copy; <a href='https://brendondsouza.com/'>Brendon D'Souza. All rights reserved.</a></h6>

    </footer>
  )
}